document.addEventListener('DOMContentLoaded', () => {
	document.addEventListener('click', (e) => {
		if (e.target instanceof HTMLElement) {
			const button = e.target.closest('.js-show-more-references');
            const wrapper = document.querySelector('.references__wrapper');

			if (button && wrapper && !wrapper.classList.contains('references__wrapper--open')) {
				wrapper.classList.add('references__wrapper--open');
			} else if (button && wrapper) {
				wrapper.classList.remove('references__wrapper--open');
            }
		}
	});
});
